"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("../../../../../ww_project/Resources/Private/app/components/AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../../../../../ww_project/Resources/Private/app/data/constantsClasses");
var TopicsDetail = /** @class */ (function (_super) {
    __extends(TopicsDetail, _super);
    function TopicsDetail() {
        var _this = _super.call(this, constants_1.DATA_TOPICS_DETAIL_MAGAZINES) || this;
        if (!_this.getElement())
            return _this;
        _this.button = _this.getElement().querySelector("[".concat(constants_1.DATA_TOPICS_DETAIL_MAGAZINES_BUTTON, "]"));
        _this.cards = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_MAGAZINE_CARD, "]"));
        _this.initEventListeners();
        return _this;
    }
    TopicsDetail.prototype.initEventListeners = function () {
        var _this = this;
        var _a;
        (_a = this.button) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            var _a, _b;
            console.log('click');
            var i = 0;
            (_a = _this.cards) === null || _a === void 0 ? void 0 : _a.forEach(function (card) {
                if (card.classList.contains(constantsClasses_1.CLASS_DNONE) && i < 16) {
                    card.classList.remove(constantsClasses_1.CLASS_DNONE);
                    i += 1;
                }
            });
            var allCards = true;
            (_b = _this.cards) === null || _b === void 0 ? void 0 : _b.forEach(function (card) {
                if (card.classList.contains(constantsClasses_1.CLASS_DNONE)) {
                    allCards = false;
                    return;
                }
            });
            if (allCards)
                _this.button.remove();
        });
    };
    return TopicsDetail;
}(AbstractComponent_1.default));
exports.default = TopicsDetail;
